import { takeLatest, put, select } from 'redux-saga/effects';
import * as types from './types';
import { metricSelector } from './selectors';
import { setMetrics } from './actions';
import { addMetricsToList } from '@components/common/DnD/utils';
import {
  allDimensionsListSelector,
  dimensionByTypesSelector,
} from '@store/common/dimensionList/selectors';
import { DIMENSION_TYPES_CONSTANTS, METRICS_TYPES_EXCLUDE_BY_FILTER } from '@utils/metrics';
import { metricsByTypesSelector } from '@store/common/selectors';
import { setDimensionsToNA } from '@store/trends/base/actions';

// add summary panel metric
function* addSummaryMetric(action) {
  const { metric } = action;
  const chartMetrics = yield select(metricSelector);

  yield put(setMetrics(addMetricsToList(chartMetrics, [metric])));
}

export function* selectedMetricChart(action) {
  const { metricName } = action;
  const allDimensions = yield select(allDimensionsListSelector);
  const dimensionByTypes = yield select(dimensionByTypesSelector);
  const metricsByTypes = yield select(metricsByTypesSelector);

  const isMetricContentMetric = METRICS_TYPES_EXCLUDE_BY_FILTER[
    DIMENSION_TYPES_CONSTANTS.ai
  ].includes(metricsByTypes[metricName]);

  if (isMetricContentMetric) {
    const dimensionsToNA = allDimensions
      .filter(
        (d) =>
          d.groupBy in dimensionByTypes &&
          dimensionByTypes[d.groupBy] === DIMENSION_TYPES_CONSTANTS.ai,
      )
      .map((d) => d.groupBy);
    yield put(setDimensionsToNA(dimensionsToNA || []));
  } else {
    yield put(setDimensionsToNA([]));
  }
}

function* watchSummaryAction() {
  yield takeLatest(types.ADD_SUMMARY_METRIC, addSummaryMetric);
}

function* watchSelectedChartMetric() {
  yield takeLatest(types.SELECTED_METRIC_CHART, selectedMetricChart);
}

export default [watchSummaryAction, watchSelectedChartMetric];
